import { render } from "./ProjectsList.vue?vue&type=template&id=03a5511b"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"
script.render = render

export default script